import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';
// import Swiper and modules styles

const swiperRows = document.querySelectorAll( '.swiper-row' );

swiperRows.forEach( ( row ) => {
	row.querySelectorAll( '.swiper-wrapper > .amdg-column' ).forEach(
		( slide ) => {
			slide.classList.add( 'swiper-slide' );
		}
	);

	// console.log( row.dataset.slidesPerView );
	// console.log( row.dataset.spaceBetween );
	// console.log( row.dataset.mobileSpaceBetween );
	// console.log( row.dataset.sliderBreakpoint );
	const slides = row.querySelectorAll( '.swiper-slide' );
	// console.log( slides.length );
	// // init Swiper:
	const swiper = new Swiper( `#${ row.id }`, {
		// configure Swiper to use modules
		enabled:
			( row.dataset.sliderLoop === '1' && slides.length > 1 ) ||
			( row.dataset.sliderLoop !== '1' && slides.length > 1 )
				? true
				: false,
		modules: [ Navigation, Pagination, EffectFade, Autoplay ],
		spaceBetween: Number( row.dataset.mobileSpaceBetween ),
		slidesPerView: 1,
		slidesPerGroup: 1,
		centeredSlides: true,
		loop: row.dataset.sliderLoop,
		autoplay: row.dataset.autoplay
			? {
					delay: row.dataset.swiperAutoplay
						? row.dataset.swiperAutoplay
						: 3000,
			  }
			: false,
		effect: row.dataset.effect,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			// when window width is >=
			[ String( row.dataset.sliderBreakpoint ) ]: {
				slidesPerView: Number( row.dataset.slidesPerView ),
				slidesPerGroup: Number( row.dataset.slidesPerView ),
				spaceBetween: Number( row.dataset.spaceBetween ),
				centeredSlides: false,
				centeredSlidesBounds: false,
				loop: row.dataset.sliderLoop,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
			disabledClass: 'swiper-button-disabled',
		},
	} );
} );
